import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { UnreadIndicator } from 'unity-chat-lib'

import { Button } from '@UI/Button'

import useToggle from '@hooks/useToggle'

import { useGetInfoAbutMeQuery } from '@store/profile/profile.api'
import { useGetStudentSubjectsQuery } from '@store/student/student.api'

// import { useGetTeacherSubjectsQuery } from '@store/teacher/teacher.api'
import { extraClass, navListMatch } from './AsideNavigation.data'
import type { AsideNavigationProps, NavAccordionProps } from './AsideNavigation.props'

export function AsideNavigation({ ...props }: AsideNavigationProps) {
  const { data } = useGetInfoAbutMeQuery({})

  // const { data: teacherSubjects, isError: teacherSubjectsError } = useGetTeacherSubjectsQuery({}, { skip: !data || data?.role !== 20 })
  // const { data: studentSubjects, isError: studentSubjectsError } = useGetStudentSubjectsQuery({}, { skip: !data || (data?.role !== 2 && data?.role !== 4) })

  const [navList, setNavList] = useState<NavAccordionProps[]>([])

  useEffect(() => {
    switch (data?.role) {
      case 100:
      case 20: {
        // if (teacherSubjects) {
        //   const subjectsNavItem = {
        //     id: 8,
        //     imgId: 'book',
        //     name: 'Предмети',
        //     link: '/teacher/subjects',
        //     list: teacherSubjects?.map((v) => ({ name: `${v.title} - ${v.classroom?.name}`, link: `/teacher/subject/${v.id}` })),
        //   }

        //   setNavList([...navListMatch[20], subjectsNavItem])
        // }

        // if (teacherSubjectsError) {
        //   setNavList(navListMatch[20])
        // }

        const subjectsNavItem = {
          id: 9,
          imgId: 'book',
          name: 'Предмети',
          link: '/teacher/subjects',
        }

        const invitationsNavItem = {
          id: 10,
          imgId: 'arrived-letter',
          name: 'Запрошення',
          link: '/admin/invitations',
          list: [],
        }

        const studentsListNavItem = {
          id: 11,
          imgId: 'childrens',
          name: 'Список учнів',
          link: '/admin/students',
          list: [],
        }

        const staffListNavItem = {
          id: 11,
          imgId: 'staff',
          name: 'Співробітники',
          link: '/admin/staff/list',
          list: [],
        }

        setNavList([...navListMatch[20], subjectsNavItem, invitationsNavItem, studentsListNavItem, staffListNavItem])

        break
      }
      case 10: {
        setNavList(navListMatch[10])

        break
      }
      case 4: {
        setNavList(navListMatch[4])

        break
      }
      case 2: {
        // if (studentSubjects) {
        //   const subjectsNavItem = {
        //     id: 8,
        //     imgId: 'book',
        //     name: 'Предмети',
        //     link: '/student/subjects',
        //     list: studentSubjects?.subjects.map((v) => ({ name: v.title, link: `/student/subject/${v.id}` })),
        //   }

        //   setNavList([...navListMatch[data?.role], subjectsNavItem])
        // }

        // if (studentSubjectsError) {
        //   setNavList(navListMatch[data?.role])
        // }

        setNavList(navListMatch[data?.role])

        break
      }
    }

    const permissions = new Set(data?.permissions?.map((p) => p.id))

    setNavList((prev) => [
      ...prev,
      ...(permissions.has(10)
        ? [
            {
              id: prev.length,
              imgId: 'check-list',
              name: 'ІНП',
              link: '/teacher/individual-plan',
              list: [],
            },
          ]
        : []),
      ...(permissions.has(9)
        ? [
            {
              id: prev.length + 1,
              imgId: 'check-list',
              name: 'Створити ІНП',
              link: '/create-individual-plan',
              list: [],
            },
          ]
        : []),
    ])
  }, [data])
  // }, [data, studentSubjects, studentSubjectsError])

  return (
    <nav className="aside__navigation nav">
      <ul className="nav__list">
        {navList?.map((v) => (
          <li
            key={`${v.id}${v.name}`}
            className={classNames('nav__item', extraClass[v.link])}
          >
            {!!v?.list?.length ? (
              <NavAccordion {...v} />
            ) : (
              <NavLink
                to={v.link}
                className={({ isActive }) => classNames('nav__link', { 'nav__link--active': isActive })}
              >
                {v.link === '/chats' ? (
                  <UnreadIndicator
                    API_URL={process.env.REACT_APP_CHAT_API_URL}
                    WS_URL={process.env.REACT_APP_CHAT_WS_URL}
                  >
                    <svg className="nav__link-svg">
                      <use href={`/img/sprite.svg#${v.imgId}`}></use>
                    </svg>
                  </UnreadIndicator>
                ) : (
                  <svg className="nav__link-svg">
                    <use href={`/img/sprite.svg#${v.imgId}`}></use>
                  </svg>
                )}

                <span className="nav__link-text">{v.name}</span>
              </NavLink>
            )}
          </li>
        ))}
      </ul>

      {/* <Button
        variant="border"
        className="aside__button-link"
        fulFill
        href="https://front-courses.vercel.app/"
        target="_blank"
      >
        <svg className="btn__icon">
          <use href="/img/sprite.svg#home"></use>
        </svg>
        <span>Курси</span>
      </Button> */}

      {/*TODO: wait TipBlock from back-end*/}
      {/*<TipBlock className={'nav__tip'} />*/}
    </nav>
  )
}

function NavAccordion({ ...props }: NavAccordionProps) {
  const location = useLocation()

  const dropRef = useRef<HTMLDivElement>(null)

  const [open, setOpen] = useToggle(false)
  const [dropHeight, setDropHeight] = useState(0)

  useEffect(() => {
    if (dropRef?.current) {
      setDropHeight(dropRef.current?.scrollHeight)
    }
  }, [props])

  return (
    <div className={classNames('nav__accordion', { 'nav__accordion--active': open })}>
      <div className="nav__top">
        <NavLink
          to={props.link}
          className={({ isActive }) => classNames('nav__link', { 'nav__link--active': isActive || location.pathname.includes(props.link.slice(0, -1)) })}
        >
          <svg className="nav__link-svg">
            <use href={`/img/sprite.svg#${props.imgId}`}></use>
          </svg>
          <span className="nav__link-text">{props.name}</span>
        </NavLink>
        <button
          className="nav__open"
          onClick={setOpen}
          aria-expanded={open}
          aria-label={open ? 'Закрити блок меню' : 'Відкрити меню'}
        >
          <svg className="nav__open-arrow">
            <use href="/img/sprite.svg#arrow-down-mini"></use>
          </svg>
        </button>
      </div>
      <div
        ref={dropRef}
        className="nav__down"
        style={{ maxHeight: open ? dropHeight + 'px' : 0 }}
      >
        <ul className="nav__sublist">
          {props.list?.map((w) => (
            <li
              key={w.name}
              className="nav__subitem"
            >
              <Link
                to={w.link}
                className="nav__sublink"
              >
                {w.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
